import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="cyber-panel p-6 rounded-lg text-center">
      <h1 className="text-4xl font-xianxia text-cyber-primary mb-6 cyber-title">
        404 - 页面未找到
      </h1>
      <p className="text-xl text-cyber-light mb-8">
        此处无修真法器，也许是被高人取走，或者遁入虚空。
      </p>
      <Link to="/" className="cyber-button text-lg px-8 py-3">
        返回宗门首页
      </Link>
    </div>
  );
};

export default NotFoundPage;
